export interface PhoneCountryOption {
  code: string;
  flag: string;
  labelKey: string;
}

export const PHONE_COUNTRY_OPTIONS: PhoneCountryOption[] = [
  { code: '+31', flag: '🇳🇱', labelKey: 'form.country.netherlands' },
  { code: '+32', flag: '🇧🇪', labelKey: 'form.country.belgium' },
  { code: '+33', flag: '🇫🇷', labelKey: 'form.country.france' },
  { code: '+41', flag: '🇨🇭', labelKey: 'form.country.switzerland' },
  { code: '+43', flag: '🇦🇹', labelKey: 'form.country.austria' },
  { code: '+45', flag: '🇩🇰', labelKey: 'form.country.denmark' },
  { code: '+48', flag: '🇵🇱', labelKey: 'form.country.poland' },
  { code: '+49', flag: '🇩🇪', labelKey: 'form.country.germany' },
  { code: '+90', flag: '🇹🇷', labelKey: 'form.country.turkey' }
];
